import { AlertTriangle, PackageOpen } from "lucide-react";

export const Loading = ({ label = "Memuat..." }) => (
  <div data-testid="loading-state" className="flex flex-col items-center justify-center py-20 gap-3 text-neutral-500">
    <div className="h-10 w-10 rounded-full border-4 border-neutral-200 border-t-[var(--bk-orange)] animate-spin" />
    <span className="text-sm">{label}</span>
  </div>
);

export const GridSkeleton = ({ n = 8 }) => (
  <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6" data-testid="grid-skeleton">
    {Array.from({ length: n }).map((_, i) => (
      <div key={i} className="rounded-xl border bg-white overflow-hidden">
        <div className="aspect-square bg-neutral-100 animate-pulse" />
        <div className="p-3 space-y-2">
          <div className="h-3 w-1/3 bg-neutral-100 rounded animate-pulse" />
          <div className="h-4 w-4/5 bg-neutral-100 rounded animate-pulse" />
          <div className="h-5 w-1/2 bg-neutral-100 rounded animate-pulse" />
        </div>
      </div>
    ))}
  </div>
);

export const Empty = ({ title = "Belum ada data", text, action }) => (
  <div data-testid="empty-state" className="flex flex-col items-center text-center py-16 px-6 rounded-2xl border-2 border-dashed border-neutral-300 bg-white">
    <PackageOpen className="h-12 w-12 text-[var(--bk-orange)] mb-3" />
    <h3 className="font-heading text-lg font-bold">{title}</h3>
    {text && <p className="text-sm text-neutral-600 mt-1 max-w-md">{text}</p>}
    {action && <div className="mt-5">{action}</div>}
  </div>
);

export const ErrorState = ({ text = "Gagal memuat data.", onRetry }) => (
  <div data-testid="error-state" className="flex flex-col items-center text-center py-14 px-6 rounded-2xl border border-red-200 bg-red-50">
    <AlertTriangle className="h-10 w-10 text-[var(--bk-red)] mb-2" />
    <p className="text-sm text-red-800">{text}</p>
    {onRetry && (
      <button data-testid="error-retry-button" onClick={onRetry} className="mt-4 text-sm font-semibold underline">
        Coba lagi
      </button>
    )}
  </div>
);

export const SectionHead = ({ eyebrow, title, action, color = "var(--bk-yellow)" }) => (
  <div className="flex items-end justify-between gap-4 mb-6">
    <div>
      {eyebrow && (
        <span className="inline-block text-[11px] font-bold uppercase tracking-[0.18em] px-2.5 py-1 rounded-md border-2 border-neutral-900 mb-2" style={{ background: color }}>
          {eyebrow}
        </span>
      )}
      <h2 className="font-heading text-2xl sm:text-3xl font-extrabold tracking-tight">{title}</h2>
    </div>
    {action}
  </div>
);
